import { Subject, Observable } from 'rxjs'
import { BvToastOptions } from 'bootstrap-vue'

export class Toasts {
  private _toastSubject = new Subject<any[]>()
  private _defaultOptions = {
    toaster: 'b-toaster-top-center',
    solid: true
  }

  get observable(): Observable<any[]> {
    return this._toastSubject.asObservable()
  }

  toast(message: string, options?: BvToastOptions): void {
    this._toastSubject.next([message, {
      ...this._defaultOptions,
      ...options
    }])
  }

  success(message: string, options?: BvToastOptions): void {
    this.toast(message, {
      title: 'Succes',
      variant: 'success',
      ...options
    })
  }

  error(message: string, options?: BvToastOptions): void {
    this.toast(message, {
      title: 'Error',
      variant: 'danger',
      ...options
    })
  }
}

export const toasts = new Toasts()
